<div class="privacy-wrapper">
    <div class="privacy-content">
        <mat-icon class="float-right " mat-dialog-close>close</mat-icon>
        <h3>Ruralx Privacy Policy</h3>
        <p class="last-updated">Last Updated: Oct 2026</p>
        <section>
            <h5>1. Introduction</h5>
            <p>
                Ruralx values your privacy and is committed to protecting your personal information.
                This Privacy Policy explains how we collect, use, and protect your data when you use
                our mobile application, website, and services.
            </p>
        </section>

        <section>
            <h5>2. Information We Collect</h5>
            <p>We may collect the following information:</p>
            <ul>
                <li>Name and contact details (phone number, email address)</li>
                <li>Delivery address and location details</li>
                <li>Order and transaction history</li>
                <li>Device information and app usage data</li>
            </ul>
        </section>

        <section>
            <h5>3. How We Use Your Information</h5>
            <ul>
                <li>To process and deliver your orders</li>
                <li>To provide customer support</li>
                <li>To improve our app and services</li>
                <li>To send order updates and important notifications</li>
            </ul>
        </section>

        <section>
            <h5>4. Payment Information</h5>
            <p>
                Online payments are processed by Razorpay or another payment provider
                made available at checkout. Your payment details are handled by the
                payment provider; Ruralx does not store your full card or payment
                credentials.
            </p>
        </section>

        <section>
            <h5>5. Data Sharing</h5>
            <p>We may share your data only with:</p>
            <ul>
                <li>Delivery partners for order fulfillment</li>
                <li>Razorpay or other payment providers to process transactions</li>
                <li>Legal authorities if required by law</li>
            </ul>
        </section>

        <section>
            <h5>6. Data Security</h5>
            <p>
                We use reasonable security measures to protect your personal data from
                unauthorized access, loss, or misuse.
            </p>
        </section>

        <section>
            <h5>7. Cookies & Tracking</h5>
            <p>
                We may use cookies or similar technologies to improve user experience,
                analyze traffic, and enhance app performance.
            </p>
        </section>

        <section>
            <h5>8. Data Retention & Your Rights</h5>
            <p>
                We retain personal information only for as long as needed to provide our
                services, meet applicable legal requirements, and resolve disputes.
            </p>
            <ul>
                <li>You may request access to or correction of your personal information</li>
                <li>You may request deletion of your account and personal information, subject to information we are required to retain by law</li>
            </ul>
            <p>
                To make a privacy or data request, email
                <strong>info@ruralx.in</strong> using the email address or phone number
                associated with your account. We may ask for information needed to verify
                your identity before acting on a request.
            </p>
        </section>

        <section>
            <h5>9. Children's Privacy</h5>
            <p>
                Ruralx services are not intended for children under 18 years without
                parental supervision.
            </p>
        </section>

        <section>
            <h5>10. Changes to Privacy Policy</h5>
            <p>
                We may update this Privacy Policy from time to time.
                Continued use of the platform means you accept updated policies.
            </p>
        </section>

        <section>
            <h5>11. Contact Us</h5>
            <p>
                If you have questions regarding this Privacy Policy, contact us:
            </p>
            <p>
                <strong>Email:</strong> info@ruralx.in<br>
                <strong>Company:</strong> Ruralx E-Trade Private Limited<br>
                <strong>Address:</strong> Ward No. 06, Nirmal Nagar, Railway Station Road,
                 Waresoni, Balaghat, Madhya Pradesh 481331, India
            </p>
        </section>

    </div>
</div>